exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-download-div a[data-v-74500d11] {\n   color: blue;\n}\n.file-download-div a[data-v-74500d11]:hover {\n   text-decoration: underline;\n   font-weight: bold;\n   color: blue;\n}\n", ""]);

// exports
